// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"WP-z","categoryName":"XP-z","categoryNameSearchHeader":"YP-z","categoryContent":"ZP-z","bottomAligned":"_P-z","image":"aQ-z","imageNoBackground":"bQ-z"};